import { inject, Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { cloneDeep } from 'lodash';
import { isAfter } from 'date-fns';
import { AuthService } from '@core/services/auth.service';

@Injectable()
export class HeadersInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    const auth = inject(AuthService);
    let reqClone = cloneDeep(request);
    const token = sessionStorage.getItem('access_token');
    const targetsAzureStorage =
      reqClone.url.includes('blob.core.windows.net') ||
      reqClone.url.includes('dfs.core.windows.net');

    if (token && !targetsAzureStorage) {
      reqClone = reqClone.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
      });
    }

    const expiresAt = JSON.parse(
      sessionStorage.getItem('expires_at') as string,
    );

    if (expiresAt && isAfter(new Date().getTime(), expiresAt)) {
      auth.logout();
    }

    return next.handle(reqClone);
  }
}
